import React,{ Component } from "react";
import { connect } from "react-redux";
import { Row, Col,  Card, CardHeader, Container} from "reactstrap";
import CastConfigForm from "../CastConfigForm/CastConfigForm";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import {updateCastConfig} from "../../../actions/actionCast";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Cast",path:"/cast",isActive: false},
    {name: "UpdateCast",path:"/updatecast",isActive: true},
];

class UpdateCastConfig extends Component{
    render(){
        return (
            <div>
                <BreadCrumbCompo routes={routes}/>
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className = "user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Update Casting Config </strong>
                                </CardHeader>
                                <CastConfigForm
                                    updateCastConfig={this.props.updateCastConfig}
                                    castConfigId={this.props.match.params.id}
                                    fromUpdate={true}
                                />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

UpdateCastConfig.propTypes = {
    updateCastConfig: Proptypes.func.isRequired,
    match: Proptypes.object
};

export default connect(state => ({
        cast_configs: state.cast.cast_configs || [],
    }),
    dispatch => ({
        updateCastConfig: (data) => dispatch(updateCastConfig(data))
    }))(UpdateCastConfig);